define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var ManagerParticipantsBubbleItemView = require("web-agent-views/ManagerParticipantsBubbleItemView");

    var ManagerParticipantsBubbleCollectionView = {};

    LE.module(CONST.MODULES.AGENT, function (LEWebAgent, LE, Backbone, Marionette, $, _) {
        ManagerParticipantsBubbleCollectionView = Marionette.CollectionView.extend({
            className: 'manager-participants-bubble',
            itemView: ManagerParticipantsBubbleItemView
        });
    });

    return ManagerParticipantsBubbleCollectionView;

});
